import * as Html from "../../util/Html.ts";
export {initDom}
Html.registerWidget('widget/form/radio',{initDom:initDom})

function initDom(elem: HTMLElement){
  const input = elem.querySelector('input') as HTMLInputElement;
  if(!input) return;

  const selectables = elem.querySelectorAll<HTMLElement>('[data-value]');

  function updateUI(){
    const value = input.value;
    selectables.forEach(obj => {
      const isSelected = obj.getAttribute('data-value') === value;
      obj.classList.toggle('selected', isSelected);
    });
  }

  input.addEventListener('change', updateUI);
  updateUI();

  selectables.forEach(selectable => {
    selectable.addEventListener('click', function(){
      const value = this.getAttribute('data-value');
      if(value) {
        input.value = value;
        input.dispatchEvent(new Event('change'));
      }
    });
  });
}
